"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupRBACValidators = void 0;

var MISSING_ROLE_1 = require("./MISSING_ROLE");

var MISSING_BINDING_TO_SERVICE_ACCOUNT_1 = require("./MISSING_BINDING_TO_SERVICE_ACCOUNT");

var MISSING_CONTAINER_TO_SERVICE_ACCOUNT_1 = require("./MISSING_CONTAINER_TO_SERVICE_ACCOUNT");

var UNSET_SERVICE_ACCOUNT_1 = require("./UNSET_SERVICE_ACCOUNT");

var UNUSED_SERVICE_ACCOUNT_1 = require("./UNUSED_SERVICE_ACCOUNT");

var UNUSED_ROLE_BINDING_1 = require("./UNUSED_ROLE_BINDING");

var UNUSED_ROLE_1 = require("./UNUSED_ROLE");

var MISSING_SVC_ACCOUNT_SECRET_1 = require("./MISSING_SVC_ACCOUNT_SECRET");

function setupRBACValidators(builder) {
  MISSING_ROLE_1.setupMISSING_ROLE(builder);
  MISSING_BINDING_TO_SERVICE_ACCOUNT_1.setupMISSING_BINDING_TO_SERVICE_ACCOUNT(builder);
  MISSING_CONTAINER_TO_SERVICE_ACCOUNT_1.setupMISSING_CONTAINER_TO_SERVICE_ACCOUNT(builder);
  UNSET_SERVICE_ACCOUNT_1.setupUNSET_SERVICE_ACCOUNT(builder);
  UNUSED_SERVICE_ACCOUNT_1.setupUNUSED_SERVICE_ACCOUNT(builder);
  UNUSED_ROLE_BINDING_1.setupUNUSED_ROLE_BINDING(builder);
  UNUSED_ROLE_1.setupUNUSED_ROLE(builder);
  MISSING_SVC_ACCOUNT_SECRET_1.setupMISSING_SVC_ACCOUNT_SECRET(builder);
}

exports.setupRBACValidators = setupRBACValidators;